import { usePortalAuth } from '@nrx/auth-ui';
import { Avatar, DropdownMenu, IconButton } from '@nrx/ui';
import type { JSX } from 'react';

interface PortalAuth {
  signoutRedirect: () => Promise<void>;
  user?: {
    profile?: {
      email?: string;
    };
  } | null;
}

/**
 * Header account menu with avatar trigger and sign-out action.
 *
 * Sign out calls auth.signoutRedirect() which:
 * 1. Redirects to the Cognito Hosted UI logout endpoint
 * 2. Hosted UI clears the Cognito session cookie
 * 3. Cognito redirects back to post_logout_redirect_uri (/auth/logout)
 * 4. oidc-client-ts clears in-memory user state
 */
export function PortalAccountMenu(): JSX.Element {
  const auth = usePortalAuth() as PortalAuth;
  const email = auth.user?.profile?.email?.trim() ?? '';
  const avatarAlt = email || 'User';

  function handleSignOut(): void {
    void auth.signoutRedirect();
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <IconButton aria-label="Account menu" className="rounded-full p-0.5">
          <Avatar alt={avatarAlt} size="sm" />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Label>{avatarAlt}</DropdownMenu.Label>
        <DropdownMenu.Separator />
        <DropdownMenu.Item onSelect={handleSignOut}>Sign out</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
